//import 'bootstrap/dist/css/bootstrap.css';
import '../src/css/modifiedBootstrap.css';
import 'bootstrap';
import '../src/css/site.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  rootElement);

unregister();

// We are opting out of service workers for now!
// Very nice explanation of service workers: https://www.oreilly.com/library/view/building-progressive-web/9781491961643/ch04.html
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js